import React, { useState, useEffect } from "react";
import { PolygonDrawer } from "../../pages/EditIgnoreZones/TestPolygonDrawer/PolygonDrawer";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { ActuateButton } from "../../common/ActuateButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import { useEditIMetadataTagZonesStore } from "./editIMetadataTagZonesStore/editIMetadataTagZonesStore";
import { pointsCreatorPlus30 } from "./EditMetadataTagZonesUtils/pointsCreatorLarger";
import { handleIncrementPointsBy30 } from "./EditMetadataTagZonesUtils/handleDecreasePointsBy30";
import { transformPixelToNormalizedCoordinates } from "./EditMetadataTagZonesUtils/transformCoordinates";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { InstructionsDialog } from "./InstructionsDialog";
// import { SchedulesTabs } from "../pages/Sites/SiteAboutPage/SchedulesTabs";

export const MetaDataTagZoneBuilder = () => {
  const {
    shapesArray,
    setShapesArray,
    dimensions,
    metadataTagZones,
    setShowAllMetadataTagZones,
    setLargerMode,
    setDimensions,
    mtzPolygonPoints,
    setMtzPolygonPoints,
    setEditorVisible,
    largerMode,
    imageURLmdtz,
    setEditsMade,
    selectedMetadataTagZone,
    setMetadataTagZones,
    shapeColor,
    showAllMetadataTagZones,
    setMdtzBuilder,
    instructionsDialogOpen,
    setInstructionsDialogOpen,
    selectedMetadataTagZoneIndex,
    editedTagZoneIndexes,
    setEditedTagZoneIndexes,
  } = useEditIMetadataTagZonesStore();
  const [shapes, setShapes] = useState<number[][][]>(shapesArray || []);
  const [selectedShapeIndex, setSelectedShapeIndex] = useState<number | null>(
    null
  );
  const [polygonDrawer, setPolygonDrawer] = React.useState(<></>);
  const imageHeight = dimensions.height;
  const imageWidth = dimensions.width;

  const shapesSizeIncreaser = (shapes: number[][][]) => {
    // Increase the size of the shapes by 1.5
    return shapes.map((shape) => {
      return shape.map((point) => {
        return point.map((coord) => coord * 1.5);
      });
    });
  };

  const shapesSizeDecreaser = (shapes: number[][][]) => {
    // Decrease the size of the shapes by 1.5
    return shapes.map((shape) => {
      return shape.map((point) => {
        return point.map((coord) => coord / 1.5);
      });
    });
  };

  useEffect(() => {
    if (shapesArray && shapesArray.length > 0) {
      setShapes(shapesArray);
    }
  }, [shapesArray]);

  React.useEffect(() => {
    setPolygonDrawer(
      <PolygonDrawer
        initialPoints={[]}
        shapes={handleIncrementPointsBy30(shapes)}
        shapeColor={shapeColor}
        setShapes={setShapes}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        setIZPolygonPoints={setMtzPolygonPoints}
      />
    );
  }, [shapes, shapeColor, imageHeight, imageWidth, setMtzPolygonPoints]);

  const handleMakeLarger = () => {
    setPolygonDrawer(<></>);
    setMdtzBuilder(<></>);
    setLargerMode(true);
    setTimeout(() => {
      setDimensions({
        width: imageWidth * 1.5,
        height: imageHeight * 1.5,
      });
      // Follow IgnoreZoneBuilder pattern: add current polygon to shapes array
      const updatedShapes = [
        ...shapes,
        mtzPolygonPoints.map((numArray: number[]) =>
          numArray.map((num) => num - 30)
        ),
      ];
      // Transform existing shapes (including current polygon)
      setShapesArray(shapesSizeIncreaser(updatedShapes));
      // Clear current polygon points since it's now part of shapes
      setMtzPolygonPoints([]);
      setMdtzBuilder(<MetaDataTagZoneBuilder />);
    }, 100);
  };

  const handleMakeSmaller = () => {
    setPolygonDrawer(<></>);
    setMdtzBuilder(<></>);
    setLargerMode(false);
    setTimeout(() => {
      setDimensions({
        width: imageWidth / 1.5,
        height: imageHeight / 1.5,
      });
      // Follow IgnoreZoneBuilder pattern: add current polygon to shapes array
      const updatedShapes = [
        ...shapes,
        mtzPolygonPoints.map((numArray: number[]) =>
          numArray.map((num) => num - 30)
        ),
      ];
      // Transform existing shapes (including current polygon)
      setShapesArray(shapesSizeDecreaser(updatedShapes));
      // Clear current polygon points since it's now part of shapes
      setMtzPolygonPoints([]);
      setMdtzBuilder(<MetaDataTagZoneBuilder />);
    }, 100);
  };

  const handleClearAll = () => {
    setShapes([]);
    setSelectedShapeIndex(null);
    setMtzPolygonPoints([]);
    // setTimeout(() => {
    //   setIZBuilder(
    //     <IgnoreZoneBuilder
    //       shapeColor={localStorage.ignoreZoneColor}
    //       height={imageHeight}
    //       width={imageWidth}
    //       imageURL={JSON.parse(localStorage.preview_url)}
    //       shapesArray={[]}
    //       setIgnorezoneEditorVisible={setIgnorezoneEditorVisible}
    //       setEditsMade={setEditsMade}
    //       visibleIgnoreZones={visibleIgnoreZones}
    //       selectedIgnoreZone={selectedIgnoreZone}
    //       setVisibleIgnoreZones={setVisibleIgnoreZones}
    //       largerMode={largerMode}
    //       setLargerMode={setLargerMode}
    //       dimensions={dimensions}
    //       setIZBuilder={setIZBuilder}
    //       allIgnoreZonesShown={showAllIgnoreZones}
    //       siteSchedules={siteSchedules}
    //     />
    //   );
    // }, 1);
  };

  const handleCancel = () => {
    setEditorVisible(false);
  };

  return (
    <div>
      {instructionsDialogOpen && <InstructionsDialog />}
      <div className="font-mulish">
        <FormControlLabel
          sx={{ fontFamily: "Mulish" }}
          control={
            <Switch
              color="warning"
              defaultChecked={largerMode}
              disabled={false}
              onChange={(event) => {
                if (event.target.checked) {
                  handleMakeLarger();
                  setLargerMode(true);
                } else {
                  handleMakeSmaller();
                  setLargerMode(false);
                }
              }}
            />
          }
          label="Larger Mode"
        />
        <FormControlLabel
          sx={{
            fontFamily: "Mulish",
            color: "#001943",
          }}
          label="Show All Metadata Tag Zones"
          control={
            <Checkbox
              checked={showAllMetadataTagZones}
              color="primary"
              onChange={(event: any, result: any) => {
                if (result === true) {
                  setShowAllMetadataTagZones(true);
                } else {
                  setShowAllMetadataTagZones(false);
                }
              }}
            />
          }
        />
      </div>
      <div style={{ marginBottom: "10px" }}></div>
      {showAllMetadataTagZones && (
        <div className="absolute top-[60px] left-[10px]">
          {metadataTagZones
            .filter((object: any) => object.line_color !== shapeColor)
            .map((object: any) => {
              return (
                <div className="absolute top-[0px]" key={object.label}>
                  {object.coordinates[0] &&
                    object.coordinates.map((array: any, index: any) => {
                      return (
                        <svg
                          className="absolute top-[0px]"
                          key={index}
                          style={{
                            width: `${imageWidth + 30}px`,
                            height: `${imageHeight + 30}px`,
                          }}
                        >
                          {dimensions && (
                            <polygon
                              points={pointsCreatorPlus30(
                                object.coordinates[index],
                                imageHeight,
                                imageWidth
                              )}
                              stroke={object.line_color}
                              strokeWidth="5"
                              fill={object.line_color}
                              fillOpacity="50%"
                            />
                          )}
                        </svg>
                      );
                    })}
                </div>
              );
            })}
        </div>
      )}
      <div
        style={{
          padding: "8px", // Adjust padding as needed
          borderRadius: "4px", // Rounded corners
          backgroundColor: "white", // Optional, for visible padding area
          display: "inline-block", // Ensures the padding wraps tightly around the svg
        }}
      >
        <div className="absolute">{polygonDrawer}</div>

        <div className="pt-[30px] pl-[30px]">
          <svg
            width={imageWidth}
            height={imageHeight}
            style={{
              backgroundImage: `url(${imageURLmdtz})`,
              backgroundSize: `${imageWidth}px ${imageHeight}px`,
            }}
          >
            {shapes.map((shape, i) => (
              <polygon
                key={i}
                points={shape.map((point) => point.join(",")).join(" ")}
                fill={i === selectedShapeIndex ? shapeColor : `${shapeColor}40`}
                stroke={shapeColor}
                strokeWidth={2}
              />
            ))}
          </svg>
        </div>

        <div className="pt-[40px] pl-[20px] flex">
          <OrangeTextButton
            onClick={handleClearAll}
            text="Clear All"
            disabled={false}
          />
          <div className={largerMode ? "pl-[730px]" : "pl-[430px]"}>
            <OrangeTextButton
              onClick={() => setInstructionsDialogOpen(true)}
              text="See Instructions"
              disabled={false}
            />
          </div>
        </div>
        {showAllMetadataTagZones && (
          <div className="absolute pt-[20px] flex w-[1200px] overflow-scroll">
            {metadataTagZones.map((object: any) => {
              return (
                <div
                  key={object.label}
                  className="pr-[35px] cursor-default min-w-[100px] flex"
                >
                  <div
                    key={object.label}
                    style={{
                      height: 25,
                      width: 6,
                      background: `${object.line_color}`,
                      cursor: "default",
                    }}
                    className="absolute cursor-default"
                  ></div>
                  <p className="font-mulish text-[16px] indent-5 cursor-default">
                    {object.name}
                  </p>
                  &nbsp;
                  {object.description && (
                    <Tooltip title={object.description} placement="top">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div
        className={
          largerMode
            ? `absolute top-[0px] left-[1250px]`
            : `absolute top-[0px] left-[950px]`
        }
      >
        <OrangeTextButton
          onClick={handleCancel}
          text="Cancel"
          disabled={false}
        />
      </div>
      <div
        className={
          largerMode
            ? `absolute top-[0px] left-[1370px] w-[100px]`
            : `absolute top-[0px] left-[1070px] w-[100px]`
        }
      >
        <ActuateButton
          onClick={() => {
            setEditorVisible(false);
            setEditsMade(true);

            // Reset to smaller mode when saving (only if currently in larger mode)
            if (largerMode) {
              setLargerMode(false);
              setDimensions({
                width: imageWidth / 1.5,
                height: imageHeight / 1.5,
              });
            }

            // Follow IgnoreZoneBuilder pattern for coordinate handling
            // Decrease polygon points by 30 (like IgnoreZoneBuilder line 407-411)
            const updatedMDTZPolygonPoints = mtzPolygonPoints.map(
              (array: number[]) => {
                return array.map((num) => num - 30);
              }
            );

            // Combine existing shapes with new polygon points
            const updatedShapes = [...shapes, updatedMDTZPolygonPoints];

            // Convert pixel coordinates back to normalized coordinates for API
            const normalizedCoordinates = transformPixelToNormalizedCoordinates(
              updatedShapes,
              imageWidth,
              imageHeight
            );

            // Create updated metadata tag zone with new coordinates
            const updatedSelectedZone = {
              ...selectedMetadataTagZone,
              coordinates: normalizedCoordinates,
            };

            // Check if the zone already exists in metadataTagZones by id
            // Only check by ID if both zones have IDs
            const existingZoneIndex = selectedMetadataTagZone.id
              ? metadataTagZones.findIndex(
                  (zone: any) => zone.id === selectedMetadataTagZone.id
                )
              : -1; // If no ID, treat as new zone

            let updatedMetadataTagZones: any[];

            if (existingZoneIndex !== -1) {
              // Update existing zone - preserve all existing zones and update the specific one
              updatedMetadataTagZones = [...metadataTagZones];
              updatedMetadataTagZones[existingZoneIndex] = {
                ...updatedSelectedZone,
                name: selectedMetadataTagZone.name,
                description: selectedMetadataTagZone.description,
                metric_labels: selectedMetadataTagZone.metric_labels,
              };

              // Track that this zone was edited
              if (!editedTagZoneIndexes.includes(existingZoneIndex)) {
                setEditedTagZoneIndexes([
                  ...editedTagZoneIndexes,
                  existingZoneIndex,
                ]);
              }
            } else {
              // Add new zone - preserve all existing zones and add the new one
              // Don't assign an ID - let the API handle it
              updatedMetadataTagZones = [
                ...metadataTagZones,
                {
                  ...updatedSelectedZone,
                  // Remove id property entirely - let API assign it
                  name: selectedMetadataTagZone.name,
                  description: selectedMetadataTagZone.description,
                  metric_labels: selectedMetadataTagZone.metric_labels,
                },
              ];
            }

            setMetadataTagZones(updatedMetadataTagZones);
          }}
          text="Save Edits"
          disabled={false}
        />
      </div>
    </div>
  );
};
